import React, { forwardRef, memo } from 'react';
import type { ListChildComponentProps } from 'react-window';
import type { TeamTabContextValue } from '../../TeamTabContext';
import { TEAM_ROSTER_GRID_MIN_WIDTH } from '../../teamConstants';
import { TeamRosterGridRow } from './TeamRosterGridRow';

export interface TeamRosterVirtualItemData {
  ctx: TeamTabContextValue;
  pageItems: Record<string, unknown>[];
}

function rowSlotHeight(style: ListChildComponentProps['style']): number {
  const raw = style?.height;
  if (typeof raw === 'number') return raw;
  if (typeof raw === 'string') {
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

export const TeamRosterListInner = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function TeamRosterListInner({ style, ...rest }, ref) {
    return <div ref={ref} {...rest} style={{ ...style, minWidth: TEAM_ROSTER_GRID_MIN_WIDTH }} />;
  }
);

export const TeamRosterVirtualRow = memo(function TeamRosterVirtualRow({
  index,
  style,
  data,
}: ListChildComponentProps<TeamRosterVirtualItemData>) {
  const person = data.pageItems[index];
  if (!person) return null;
  const slot = rowSlotHeight(style);
  const gap = 8;
  const innerHeight = Math.max(0, slot - gap);

  return (
    <div
      style={{
        ...style,
        boxSizing: 'border-box',
        paddingBottom: gap,
        minWidth: TEAM_ROSTER_GRID_MIN_WIDTH,
      }}
    >
      <div style={{ height: innerHeight, overflow: 'visible' }}>
        <TeamRosterGridRow person={person} ctx={data.ctx} />
      </div>
    </div>
  );
});
